"use client";
import React from "react";
import Image from "next/image";
import { Box, Center, Grid, GridItem, Stack } from "@chakra-ui/react";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import PageLayout from "@/layouts/pageLayout";
import { scrollToElement } from "@/utils/scrollToElement";
import { Fa6ArrowRight } from "@onemind-services-llc/react-icons-ng/fa6";
import { ONE_MIND_CX_CONSTANTS } from "./constants";

const OnemindCxComponent = () => {
  const { DESCRIPTION, IMAGE } = ONE_MIND_CX_CONSTANTS;
  const TextVariant = useTextVariant();
  const HeadingVariant = useHeadingVariant();
  return (
    <Box bg="#F4F7FA" py={8} my={20}>
      <PageLayout>
        <Grid
          gap={{ base: 4, lg: 12 }}
          templateColumns={{
            base: "repeat(1, 1fr)",
            md: "repeat(5, 1fr)",
          }}
        >
          <GridItem colSpan={{ base: 1, md: 2 }}>
            <Stack gap={10}>
              <Heading variant={HeadingVariant} mb={4}>
                {DESCRIPTION.title}
              </Heading>
              <Text variant={TextVariant} color="text.100">
                {DESCRIPTION.description}
              </Text>
              <Button
                variant={"ideal"}
                onClick={() => scrollToElement("contact-us", 120)}
                w="fit-content"
                p={4}
                rightIcon={<Fa6ArrowRight />}
              >
                {DESCRIPTION.btnText}
              </Button>
            </Stack>
          </GridItem>
          <GridItem colSpan={{ base: 1, md: 3 }}>
            <Center height={"full"}>
              <Box
                h={{ base: "300px", sm: "350px" }}
                w={{ base: "100%", sm: "80%", md: "80%" }}
                position="relative"
                alignSelf={"center"}
                bg="#F4F7FA"
              >
                <Image
                  src={IMAGE}
                  alt="IntroImg"
                  layout="fill"
                  objectFit="contain"
                  objectPosition="center"
                  placeholder="blur"
                  loading="lazy"
                />
              </Box>
            </Center>
          </GridItem>
        </Grid>
      </PageLayout>
    </Box>
  );
};

export default OnemindCxComponent;
